// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g68l","top":"styles_top__1yJBJ","left":"styles_left__3drmx","description":"styles_description__zAgOq"};